<script setup lang="ts">
    import InfoIcon from "@/assets/info_dark.svg";
    import KFormFieldDisplay from "@/components/forms/displays/FormFieldDisplay/KFormFieldDisplay.vue";
    import KForm from "@/components/forms/Form/KForm.vue";
    import ModalContent from "@/components/generic/ModalContent.vue";
    import { useStore } from "@/store";
    import { NllSamtycke } from "@/tabs/Receptforskrivning/types";
    import emitter from "tiny-emitter/instance";

    const store = useStore();

    const emit = defineEmits<{
        (event: "submit"): void;
        (event: "cancel"): void;
    }>();

    const onSubmit = () => {
        store.commit("nll/setAccessConsent", { accessConsent: NllSamtycke.TillfalligtSparradeUppgifter });
        emitter.emit("refreshReceptforskrivningar");

        emit("submit");
    };

    const onCancel = () => {
        emit("cancel");
    };
</script>

<template>
    <ModalContent title="Visa spärrade förskrivningar och uttag">
        <KForm
            id="sparr"
            submitContent="Visa spärrade förskrivningar och uttag"
            cancelContent="Avbryt"
            submitVariant="alert"
            class="visa-sparrade-forskrivningar"
            @submit="onSubmit"
            @cancel="onCancel"
        >
            <div class="form-content">
                <KGroup name="info" freeFlow class="span-all info" direction="horizontal" rowGap="half">
                    <img :src="InfoIcon" alt="Info" />
                    <KFormFieldDisplay
                        name="info"
                        :value="`
                        Patienten har dolt en eller flera förskrivningskedjor. Om du har patientens samtycke kan du
                        visa spärrade förskrivningar och uttag.
                    `"
                    />
                </KGroup>
                <KFormFieldDisplay
                    name="confirmation"
                    class="span-all"
                    label="Vill du visa spärrade förskrivningar och uttag?"
                    labelVariant="blue"
                    labelSize="large"
                    margin="large"
                    :value="`
                        Jag intygar att patienten samtycker till att jag får se spärrade uppgifter.
                    `"
                />
            </div>
        </KForm>
    </ModalContent>
</template>

<style lang="scss" scoped>
    @import "@/style/variables";

    .visa-sparrade-forskrivningar {
        .info {
            ::v-deep .group-content {
                flex-wrap: unset;
            }
        }
    }
</style>
